import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

const today = new Date();
today.setHours(0, 0, 0, 0); // Rimuovo il tempo dall'oggetto Date per confrontare solo le date

const startDate = new Date(today.setDate(today.getDate() + 30));

const startDate2 = new Date(today.setDate(today.getDate()));

const filterDate = (d: Date | null): boolean => {
    return d !== null && d > startDate;
};

const filterDate2 = (d: Date | null): boolean => {
    return d !== null && d > startDate2;
};

export const RichiestaDehorStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.tipo_occupazione',
                type:'mat-select',
                props: {
                    label: 'TIPO DI OCCUPAZIONE',
                    required: true,
                    options: [
                        {
                            value: 'permanente',
                            label: 'OCCUPAZIONE PERMANENTE',
                        },
                        {
                            value: 'temporanea',
                            label: 'OCCUPAZIONE TEMPORANEA',
                        },
                    ],
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.autorizzata_dal',
                type: '#data',
                props: {
                    label: 'DATA INIZIO',
                    datepickerOptions: {
                        startAt: startDate,
                        filter: filterDate,
                    },
                },
                validators: {
                    datemin: {
                        expression: (c: AbstractControl) =>
                            new Date(c.value) >= startDate,
                        message: (error: any, field: FormlyFieldConfig) =>
                            `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                    }
                },
                expressions: {
                    hide: "model.jd.tipo_occupazione != 'permanente'",
                },
            },
        ],
    },
    {
        fieldGroup: [
            {
                key: 'jd.periodo_occupazione',
                type: 'repeat',
                defaultValue: [],
                props: {
                    addText: '+ AGGIUNGI PERIODO OCCUPAZIONE',
                    label: 'PERIODI DI OCCUPAZIONE *',
                    required: true,
                },
                wrappers: ['group-panel'],
                fieldArray: {
                    fieldGroupClassName:
                        'border border-t-4 p-4 pt-6 shadow-sm rounded-xl grid grid-flow-row-dense mb-2 sm:grid-cols-1 md:grid-cols-4 gap-4',
                    fieldGroup: [
                        {
                            className: 'sm:col-span-1 md:col-span-1',
                            key: 'data_inizio',
                            type: '#data',
                            props: {
                                label: 'DATA INIZIO',
                                datepickerOptions: {
                                    startAt: startDate,
                                    filter: filterDate,
                                },
                            },
                            validators: {
                                datemin: {
                                    expression: (c: AbstractControl) =>
                                        new Date(c.value) >= startDate,
                                    message: (
                                        error: any,
                                        field: FormlyFieldConfig,
                                    ) =>
                                        `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                                },
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-1',
                            key: 'data_fine',
                            type: '#data',
                            props: {
                                label: 'DATA FINE',
                                datepickerOptions: {
                                    startAt: startDate,
                                    filter: filterDate,
                                },
                            },
                            validators: {
                                datemin: {
                                    expression: (c: AbstractControl) =>
                                        new Date(c.value) >= startDate,
                                    message: (
                                        error: any,
                                        field: FormlyFieldConfig,
                                    ) =>
                                        `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                                },
                            },
                        },
                    ],
                    validators: {
                        validation: [{ name: 'dateRangeValidator', options: { start:'data_inizio', end:'data_fine', errorPath: 'data_fine', message: 'La data di fine deve essere successiva alla data di inizio' } }],
                    },
                },
                validation :{
                    messages: {
                        required : 'Campo obbligatorio: inserisci almeno un periodo di occupazione'
                    }
                }
            },
        ],
        expressions: {
            hide: "model.jd.tipo_occupazione != 'temporanea'",
        },
    },
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-3 gap-4',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-3',
                key: 'jd.tipologia_attivita',
                type: 'mat-textarea',
                props: {
                    label: 'TIPO DI ATTIVITÀ',
                    autosize: true,
                    autosizeMaxRows: 8,
                    autosizeMinRows: 2,
                },

            },
            {
                className: 'sm:col-span-1 md:col-span-2',
                key: 'jd.numero_autorizzazione_scia',
                type: 'mat-input',
                props: {
                    label: 'NUM. AUTORIZZAZIONE / NUM. PROT SCIA ATTIVITÀ PRODUTTIVE',
                    required: true,
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.data_autorizzazione_scia',
                "type":"#data",
                "props": {
                  "label": 'DATA RILASCIO',
                  "required": true,
                  "datepickerOptions": {
                    "startAt": startDate2
                  }
                }
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.superficie_interna',
                type: 'mat-input',
                props: {
                    label: 'SUP. INTERNA DEL LOCALE IN MQ.',
                    type: 'number',
                    required: true,
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.superficie_old',
                type: 'mat-input',
                props: {
                    label: 'SUP. DEHOR ATTIVO',
                    description:
                        'Compilare SOLO in caso di richiesta di aumento di superficie già autorizzata',
                    type: 'number',
                },
            },
        ],
    },
];
